const config = {
  rowSelection: false,
  fieldControl: false,
  searchMode: "group",
  columns: [
    {
      title: "渠道ID",
      dataIndex: "id",
      width: 200,
      render: 'IDRender'
    },
    {
      title: "渠道名称",
      dataIndex: "channelName",
      ellipsis: true,
      width: 200
    },
    {
      title: "路径描述",
      dataIndex: "pathName",
      ellipsis: true,
      width: 200
    },
    {
      title: "军种",
      dataIndex: "typeName",
      width: 120
    },
    {
      title: "主被动属性",
      dataIndex: "activePassiveTypeName",
      width: 150
    },
    {
      title: "渠道分类",
      dataIndex: "channelCategoryName",
      ellipsis: true,
      width: 150
    },
    {
      title: "状态",
      dataIndex: "stateName",
      width: 100
    },
    {
      title: "合作方式",
      dataIndex: "cooperateModeName",
      width: 130
    },
    {
      title: "合作门店",
      dataIndex: "orgList",
      render: 'orgListRender',
      ellipsis: true,
      width: 280
    },
    {
      title: "费用区间",
      dataIndex: "costRange",
      render: 'costRangeRender',
      width: 130
    },
    {
      title: "合作范围",
      dataIndex: "cooperateRangeName",
      width: 120
    },
    {
      title: "提交人",
      dataIndex: "createdByName",
      width: 100
    },
    {
      title: "操作",
      dataIndex: "actionTool",
      width: 220,
      render: "actionTool",
      fixed: "right"
    }
  ],
  search: [
    {
      name: "typeId",
      label: "军种",
      itemType: "select",
      data: "typeOptions",
      key: "id",
      labelKey: "typeName",
      addonOpts: []
    },
    {
      name: "channelNameKeyword",
      label: "渠道名称",
    },
    {
      name: "channelCategoryId",
      label: "渠道分类",
      itemType: "tree",
      key: "id",
      labelKey: "label",
      data: "fluxTypeOptions",
      addonOpts: []
    },
    {
      name: "orgId",
      label: "合作门店",
      itemType: "select",
      key: "id",
      labelKey: "namePath",
      data: "orgOptions",
      addonOpts: []
    },
    {
      name: "activePassiveType",
      label: "主被动属性",
      itemType: "select",
      key: "key",
      labelKey: "description",
      data: "activePassiveTypeOptions",
      addonOpts: []
    }
  ],
  footer: [
    {
      label: "新增",
      // auth: "FlowChannelButton1",
      type: "primary",
      events: ["onClick:onAdd"]
    },
    /*{
      label: "下载关系人附件",
      // auth: "DownloadRelateFiles",
      render: 'downloadRelateFiles',
      events: ['onClick:onDownLoad']
    },*/
  ],
};

export default config
